import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import { useGetAccountQuery, Module } from '~/types/types';
import { useVentureId } from '~/functions/accounts';
export default defineComponent({
  setup: function setup() {
    var _ref = useNuxtApp(),
      $i18n = _ref.$i18n;
    var ventureId = useVentureId();
    var _useGetAccountQuery = useGetAccountQuery(computed(function () {
        return {
          id: ventureId.value
        };
      })),
      result = _useGetAccountQuery.result,
      loading = _useGetAccountQuery.loading;
    var venture = computed(function () {
      var _result$value;
      return ((_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.getAccount) || {
        modules: [],
        portfolioLinks: []
      };
    });

    // TODO please move this and merge with modules once we have a clearer ideas of module vs tabs
    var headers = computed(function () {
      var _venture$value, _venture$value$booked, _venture$value2, _venture$value2$booke, _venture$value3, _venture$value3$booke, _venture$value4, _venture$value4$booke, _venture$value5, _venture$value5$booke, _venture$value6, _venture$value6$booke;
      return [{
        label: $i18n.t('general.headers.modules'),
        link: 'venture-modules',
        showForModules: (_venture$value = venture.value) === null || _venture$value === void 0 ? void 0 : (_venture$value$booked = _venture$value.bookedModules) === null || _venture$value$booked === void 0 ? void 0 : _venture$value$booked.some(function (module) {
          return [Module.Esg, Module.Metrics, Module.ImpactGoal].includes(module);
        })
      }, {
        label: $i18n.t('general.headers.companyInfo'),
        link: 'venture-company',
        showForModules: (_venture$value2 = venture.value) === null || _venture$value2 === void 0 ? void 0 : (_venture$value2$booke = _venture$value2.bookedModules) === null || _venture$value2$booke === void 0 ? void 0 : _venture$value2$booke.includes(Module.CompanyInfo)
      }, {
        label: $i18n.t('general.headers.esg'),
        link: 'venture-esg',
        showForModules: (_venture$value3 = venture.value) === null || _venture$value3 === void 0 ? void 0 : (_venture$value3$booke = _venture$value3.bookedModules) === null || _venture$value3$booke === void 0 ? void 0 : _venture$value3$booke.includes(Module.Esg)
      }, {
        label: $i18n.t('general.headers.impactGoal'),
        link: 'venture-impact',
        showForModules: (_venture$value4 = venture.value) === null || _venture$value4 === void 0 ? void 0 : (_venture$value4$booke = _venture$value4.bookedModules) === null || _venture$value4$booke === void 0 ? void 0 : _venture$value4$booke.includes(Module.ImpactGoal)
      }, {
        label: $i18n.t('general.headers.kpis'),
        link: 'venture-metrics',
        showForModules: (_venture$value5 = venture.value) === null || _venture$value5 === void 0 ? void 0 : (_venture$value5$booke = _venture$value5.bookedModules) === null || _venture$value5$booke === void 0 ? void 0 : _venture$value5$booke.includes(Module.Metrics)
      }, {
        label: $i18n.t('general.headers.impactScreening'),
        link: 'venture-impactScreening',
        showForModules: (_venture$value6 = venture.value) === null || _venture$value6 === void 0 ? void 0 : (_venture$value6$booke = _venture$value6.bookedModules) === null || _venture$value6$booke === void 0 ? void 0 : _venture$value6$booke.includes(Module.ImpactScreening)
      }].filter(function (header) {
        return header.showForModules;
      });
    });
    var activeTab = ref('venture-modules');
    return {
      loading: loading,
      headers: headers,
      activeTab: activeTab,
      venture: venture
    };
  },
  computed: {
    currentTitle: function currentTitle() {
      if (this.$route.path.includes('modules')) {
        return 'Available modules';
      }
      return null;
    }
  }
});